// components/StyledHeader.jsx
import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box
} from "@mui/material";
import { Menu } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import imagelogo from "../../../Images/imagelogo-removebg-preview(1).png";

const StyledHeader = ({ onMenuClick }) => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        top: 0,
        zIndex: 1300,
        bgcolor: "#ffffff",
        borderBottom: "1px solid #e5e7eb"
      }}
    >
      <Toolbar
        sx={{
          minHeight: "64px !important",
          px: 2,
          display: "flex",
          alignItems: "center"
        }}
      >
        {/* ================= LOGO (HOME) ================= */}
        <Box
          onClick={() => navigate("/")}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
          }}
        >
          <img
            src={imagelogo}
            alt="Himachal Tours Logo"
            style={{
              height: 74,
              width: 106,
              objectFit: "contain"
            }}
          />

          <Box> 
            <Typography fontWeight={700} color="#065f46"> Himachal Tours with Ajju </Typography> 
          <Typography variant="caption" color="#6b7280"> Your Adventure Partner </Typography>
           </Box> 
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        {/* ================= MENU BUTTON ================= */}
        <IconButton
          onClick={onMenuClick}
          sx={{
            width: 42,
            height: 42,
            borderRadius: "10px",
            background: "#f0fdf4",
            color: "#065f46",
            transition: "0.2s",
            "&:active": {
              transform: "scale(0.9)"
            }
          }}
        >
          <Menu sx={{ fontSize: 26 }} />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default StyledHeader;
